// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import CheckoutConstants from '../Checkout.constants';

const { SHIPPING_EDITING_DEFAULT_PARAM, SHIPPING_DEFAULT_PARAM } = CheckoutConstants;

const initialState = fromJS({
  values: {
    pickUpContact: {},
    pickUpAlternative: {},
    shipping: {},
    billing: {},
    giftWrap: {},
    smsInfo: {
      numberForUpdates: null,
      numberForMarketing: null,
    },
    selectedShippingPhoneNumber: '',
    giftCards: [],
    venmoData: {
      nonce: '',
      deviceData: '',
      supportedByBrowser: true,
      loading: false,
      timestamp: '',
      error: null,
    },
    venmoClientTokenData: {
      userState: 'G',
      venmoCustomerIdAvailable: false,
      venmoIsDefaultPaymentType: false,
      venmoPaymentTokenAvailable: false,
      venmoSecurityToken: '',
    },
    appleClientTokenData: {
      userState: 'G',
      clientToken: '',
    },
    appleShippingData: {
      countryCode: '',
      administrativeArea: '',
      postalCode: '',
      locality: '',
      familyName: '',
      givenName: '',
      phoneNumber: '',
      emailAddress: '',
    },
    applePayAppData: {
      loading: true,
      isEligibleForApplePay: true,
    },
    addEditResponseAddressId: null,
    giftCardError: null,
    isShippingFormLoading: false,
    orderBalanceTotal: 0,
    paySecureSessionId: null,
    hasCardBeenTokenized: false,
    isExpressCallDoneThroughPlccIcFailure: false,
    isSubmitOrderError: false,
    isSubmitOrderErrorCode: '',
    isGiftServicesLoading: false,
  },
  options: {
    shippingMethods: [],
    giftWrapOptions: [],
    paypalPaymentSettings: null,
    internationalUrl: null,
  },
  uiFlags: {
    stage: CheckoutConstants.CHECKOUT_STAGES.SHIPPING,
    prevStage: CheckoutConstants.CHECKOUT_STAGES.SHIPPING,
    routingDone: false,
    orderUpdateViaMsg: false,
    stageChangeCount: 0,
    isGiftOptionsEnabled: true,
    isPLCCPaymentEnabled: false,
    maxGiftCards: 5,
    isPaypalPaymentInProgress: false,
    venmoPaymentInProgress: false,
    applePaymentInProgress: false,
    afterPayInProgress: false,
    paypalPaymentInProgress: false,
    venmoPickupMessageDisplayed: false,
    venmoShppingMessageDisplayed: false,
    venmoPaymentOptionSave: false,
    venmoAppInstalled: true,
    isLoadingShippingMethods: false,
    isUpdatingShipmentMethods: false,
    isEditingSubform: false,
    isBillingVisited: false,
    isReviewVisited: false,
    alertMessage: null,
    paymentError: null,
    addressError: null,
    checkoutServerError: null,
    isRTPSFlow: false,
    checkoutPageFocus: false,
    initCheckoutFinished: false,
    saveCardToAccountUserChoice: null,
    couponRemovedFromOrder: false,
    checkoutClientError: null,
    appleLoaderState: false,
    isExpressAfterPayFlow: false,
  },
  recaptcha: false,
});

const mergedVenmoDetails = (state, payload) => {
  const currentValue = fromJS(state.getIn(['values', 'venmoData']));
  return currentValue.merge(payload).toObject();
};

const mergedApplePayAppDetails = (state, payload) => {
  const currentValue = fromJS(state.getIn(['values', 'applePayAppData']));
  return currentValue.merge(payload).toObject();
};
function appleFlagReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.GET_APPLE_CLIENT_TOKEN_SUCCESS:
      return checkout.setIn(
        ['values', 'appleClientTokenData'],
        action.payload && action.payload.appleClientTokenData
      );
    case CheckoutConstants.SET_APPLE_PAYMENT_INPROGRESS: {
      return checkout.setIn(['uiFlags', 'applePaymentInProgress'], action.payload);
    }
    case CheckoutConstants.SET_APPLE_PAY_DATA_APP: {
      const applePayData = mergedApplePayAppDetails(checkout, action.payload);
      return checkout.setIn(['values', 'applePayAppData'], applePayData);
    }
    case CheckoutConstants.SAVE_CARD_CHOICE: {
      let userChoice = action.payload ? 'save' : 'donotsave';
      if (action.payload === null) {
        userChoice = null;
      }
      return checkout.setIn(['uiFlags', 'saveCardToAccountUserChoice'], userChoice);
    }
    case CheckoutConstants.SET_AFTERPAY_INPROGRESS: {
      return checkout.setIn(['uiFlags', 'afterPayInProgress'], action.payload);
    }
    case CheckoutConstants.SET_AFTERPAY_PAYMENT_PROGRESS: {
      return checkout.setIn(['uiFlags', 'afterPayPaymentProgress'], action.payload);
    }
    case CheckoutConstants.COUPON_REMOVED: {
      return checkout.setIn(['uiFlags', 'couponRemovedFromOrder'], action.payload);
    }
    case CheckoutConstants.SET_AFTERPAY_DRAWER: {
      return checkout.setIn(['uiFlags', 'showCouponsDrawer'], action.payload);
    }
    case CheckoutConstants.SET_PAYPAL_PAYMENT_PROGRESS: {
      return checkout.setIn(['uiFlags', 'paypalPaymentInProgress'], action.payload);
    }

    default:
      return checkout;
  }
}

export function venmoFlagReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.GET_VENMO_CLIENT_TOKEN_SUCCESS:
      return checkout.setIn(
        ['values', 'venmoClientTokenData'],
        action.payload && action.payload.venmoClientTokenData
      );
    case CheckoutConstants.GET_VENMO_CLIENT_TOKEN_ERROR:
      return checkout.setIn(['values', 'venmoData'], action.payload);
    case CheckoutConstants.SET_SELECTED_COUNTRY_DROPDOWN:
      return checkout.setIn(['values', 'phoneCountryCode'], action.payload);
    case CheckoutConstants.SET_SELECTED_COUNTRY_DROPDOWN_PICKUP:
      return checkout.setIn(['values', 'phoneCountryCodePickup'], action.payload);
    case CheckoutConstants.SET_VENMO_DATA: {
      const venmoData = mergedVenmoDetails(checkout, action.payload);
      return checkout.setIn(['values', 'venmoData'], venmoData);
    }
    case CheckoutConstants.SET_VENMO_PAYMENT_INPROGRESS: {
      return checkout.setIn(['uiFlags', 'venmoPaymentInProgress'], action.payload);
    }
    case CheckoutConstants.SET_VENMO_PICKUP_MESSAGE_STATE: {
      return checkout.setIn(['uiFlags', 'venmoPickupMessageDisplayed'], action.payload);
    }
    case CheckoutConstants.SET_VENMO_SHIPPING_MESSAGE_STATE: {
      return checkout.setIn(['uiFlags', 'venmoShippingMessageDisplayed'], action.payload);
    }
    case CheckoutConstants.SET_VENMO_PAYMENT_OPTION_SAVE: {
      return checkout.setIn(['uiFlags', 'venmoPaymentOptionSave'], action.payload);
    }
    case CheckoutConstants.SET_VENMO_APP_INSTALLED: {
      return checkout.setIn(['uiFlags', 'venmoAppInstalled'], action.payload);
    }
    default:
      return appleFlagReducer(checkout, action);
  }
}

export function paypalReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.CHECKOUT_ORDER_OPTIONS_SET_PAYPAL_PAYMENT:
      return checkout.setIn(['options', 'paypalPaymentSettings'], action.paypalPaymentSettings);
    case CheckoutConstants.SET_IS_RTPS_FLOW:
      return checkout.setIn(['uiFlags', 'isRTPSFlow'], action.payload);
    case CheckoutConstants.CHECKOUT_ROUTING_DONE:
      return checkout.setIn(['uiFlags', 'routingDone'], action.payload);
    case CheckoutConstants.REDIRECT_FROM_EXPRESS:
      return checkout.setIn(['uiFlags', 'redirectFromExpress'], action.payload);
    case CheckoutConstants.CHECKOUT_VALUES_SET_GIFTWRAP:
      return checkout.setIn(['values', 'giftWrap'], action.payload);
    case CheckoutConstants.CHECKOUT_FLAGS_SET_PICKUP_UPDATE_FOR_MSG:
      return checkout.setIn(['values', 'orderUpdateViaMsg'], action.payload);
    case CheckoutConstants.SET_CHECKOUT_FOCUS: {
      return checkout.setIn(['uiFlags', 'checkoutPageFocus'], action.payload);
    }
    case CheckoutConstants.SET_INIT_CHECKOUT_FINISHED: {
      return checkout.setIn(['uiFlags', 'initCheckoutFinished'], action.payload);
    }
    default:
      return venmoFlagReducer(checkout, action);
  }
}

function paySecureReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.FETCH_PAY_SECURE_SESSION_ID_SUCCESS:
      return checkout.setIn(
        ['values', 'paySecureSessionId'],
        action.payload && action.payload.SessionId
      );
    case CheckoutConstants.FETCH_PAY_SECURE_SESSION_ID_ERROR:
      return checkout.setIn(['values', 'paySecureError'], action.payload);
    case CheckoutConstants.UPDATE_CARD_TOKENIZATION:
      return checkout.setIn(['values', 'hasCardBeenTokenized'], action.payload);
    case CheckoutConstants.RESET_PAY_SECURE:
      return checkout
        .setIn(['values', 'paySecureSessionId'], '')
        .setIn(['values', 'hasCardBeenTokenized'], false);
    default:
      return paypalReducer(checkout, action);
  }
}

export function uiGiftCardFlagReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_SHOW:
      return checkout
        .setIn(['values', 'addGiftCardError'], null)
        .setIn(['values', 'showAddGiftCard'], true);
    case CheckoutConstants.CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_HIDE:
      return checkout.setIn(['values', 'showAddGiftCard'], false);
    case CheckoutConstants.ADD_GIFT_CARD_SUCCESS:
      return checkout.setIn(['values', 'addGiftCardResponse'], 'success');
    case CheckoutConstants.ADD_GIFT_CARD_FAILED:
      return checkout
        .setIn(['values', 'addGiftCardError'], fromJS(action.payload.errorMessage))
        .setIn(['values', 'addGiftCardErrorCode'], fromJS(action.payload.errorCode));
    case CheckoutConstants.RESET_ADD_GIFT_CARD:
      return checkout.setIn(['values', 'addGiftCardError'], null);
    case CheckoutConstants.RESET_ADD_GIFT_CARD_SUCCESS:
      return checkout.setIn(['values', 'addGiftCardResponse'], null);
    case CheckoutConstants.RESET_CHECKOUT_REDUCER:
      return initialState;
    case CheckoutConstants.CHECKOUT_VALUES_SET_SHIPPING_LOADING:
      return checkout.setIn(['values', 'isShippingFormLoading'], action.isLoading);
    case CheckoutConstants.SET_SERVER_ERROR_CHECKOUT:
      return checkout.setIn(['uiFlags', 'checkoutServerError'], action.payload);
    case CheckoutConstants.SET_CHECKOUT_CLIENT_ERROR:
      return checkout.setIn(['uiFlags', 'checkoutClientError'], action.payload);
    case CheckoutConstants.IS_GIFT_SERVICES_LOADING:
      return checkout.setIn(['values', 'isGiftServicesLoading'], action.payload);
    default:
      return paySecureReducer(checkout, action);
  }
}

function setCheckoutStage(checkout, payload) {
  const prevCheckoutStage =
    checkout.getIn(['uiFlags', 'stage']) && checkout.getIn(['uiFlags', 'stage']).toLowerCase();
  if (prevCheckoutStage === (payload && payload.toLowerCase())) return checkout;
  if (payload === SHIPPING_EDITING_DEFAULT_PARAM) {
    return checkout
      .setIn(['uiFlags', 'stage'], SHIPPING_DEFAULT_PARAM)
      .setIn(['uiFlags', 'prevStage'], prevCheckoutStage)
      .setIn(['uiFlags', 'editShipping'], true);
  }
  return checkout
    .setIn(['uiFlags', 'stage'], payload)
    .setIn(['uiFlags', 'prevStage'], prevCheckoutStage)
    .setIn(['uiFlags', 'editShipping'], false);
}

function uiFlagReducer(checkout, action) {
  switch (action.type) {
    case CheckoutConstants.CHECKOUT_FLAGS_SET_LOAD_METHODS:
      return checkout.setIn(['uiFlags', 'isLoadingShippingMethods'], action.isLoading);
    case CheckoutConstants.CHECKOUT_SET_LOAD_SHIPMENT_METHODS:
      return checkout.setIn(['uiFlags', 'isUpdatingShipmentMethods'], action.isLoading);
    case 'CHECKOUT_FLAGS_SET_EDITING_SUBFORM':
      return checkout.setIn(['uiFlags', 'isEditingSubform'], action.isEditingSubform);
    case 'CHECKOUT_UIFLAGS_SET_STAGE':
      return setCheckoutStage(checkout, action.payload);
    case CheckoutConstants.CHECKOUT_FLAGS_SET_BILLING_VISITED:
      return checkout.setIn(['uiFlags', 'isBillingVisited'], action.isBillingVisited);
    case CheckoutConstants.SET_GIFTCARD_ERROR:
      return checkout.setIn(['values', 'giftCardError'], action.payload);
    case CheckoutConstants.RESET_GIFTCARD_ERROR:
      return checkout.setIn(['values', 'giftCardError'], null);
    case CheckoutConstants.SET_ORDER_TOTAL:
      return checkout.setIn(['values', 'orderBalanceTotal'], action.payload);
    case CheckoutConstants.CHECKOUT_VAlUES_SET_GIFT_WRAP:
      return checkout.CartPageReducer.setIn(['orderDetails', 'checkout', 'giftWrap']);
    case 'CHECKOUT_ORDER_OPTIONS_SET_INTL_URL':
      return checkout.setIn(['options', 'internationalUrl'], action.internationalUrl);
    // case 'CHECKOUT_FLAGS_SET_REVIEW_VISTED':
    //   return merge(uiFlags, { isReviewVisited: action.payload });
    // case 'CHECKOUT_FLAGS_SET_PAYMENT_ERROR':
    //   return merge(uiFlags, { paymentError: action.paymentError });
    // case CheckoutConstants.CHECKOUT_FLAGS_SET_ADDRESS_ERROR:
    //   return checkout.setIn(['uiFlags', 'addressError'], action.addressError);
    // case 'CHECKOUT_FLAGS_SET_VENMO_INFO_MESG_DISPLAYED':
    //   return uiFlags.setIn(['venmoInformationMessageDisplayed'], action.payload);
    // case actionTypes.CHANGE: { // Listen in on redux-form change events and enjoy the pure function approach
    //    const { meta, payload } = action;
    //    const { form, field } = meta;
    //    if (form === 'checkoutBilling' && field === 'paymentMethod') {
    //      const result = payload === 'venmo';
    //      return uiFlags.setIn(['venmoPaymentInProgress'], result);
    //    }
    //    return uiFlags;
    //  }
    default:
      return uiGiftCardFlagReducer(checkout, action);
  }
}

/* eslint-disable complexity */
export default function CheckoutReducer(state = initialState, action) {
  let checkout = state;
  if (checkout instanceof Object) {
    checkout = fromJS(checkout);
  }
  // const orderValues = checkout.get('values');
  // const orderOptions = checkout.get('options');
  // const uiFlags = checkout.get('uiFlags');
  switch (action.type) {
    case 'CHECKOUT_VALUES_SET_PICKUP':
      return checkout.setIn(['values', 'pickUpContact'], action.pickUpContact);
    case 'CHECKOUT_VALUES_SET_PICKUP_ALT':
      return checkout.setIn(['values', 'pickUpAlternative'], action.pickUpAlternative);
    // case 'CHECKOUT_VALUES_SET_GIFTCARDS':
    //   return merge(orderValues, { giftCards: action.giftCards });
    case 'CHECKOUT_VALUES_SET_SHIPPING':
      return checkout.setIn(['values', 'shipping'], action.shipping);
    case 'CHECKOUT_ORDER_OPTIONS_SET_GIFT_WRAP':
      return checkout.setIn(['options', 'giftWrapOptions'], action.giftWrapOptions);
    case 'CHECKOUT_VALUES_SET_BILLING':
      return checkout.setIn(['values', 'billing'], action.billing);
    // case 'CHECKOUT_VALUES_SET_SHIPPING_METHOD':
    //   return orderValues.setIn(['shipping', 'method'], action.method);
    // case 'CHECKOUT_VALUES_SET_GIFT_WRAP':
    //   return merge(orderValues, { giftWrap: action.giftWrap });
    case CheckoutConstants.CHECKOUT_VALUES_SET_SMS_UPDATES:
      return checkout.setIn(['values', 'smsInfo'], { numberForUpdates: action.phoneNumber });
    case CheckoutConstants.SET_ON_FILE_ADDRESS_KEY:
      return checkout.setIn(['values', 'addEditResponseAddressId'], action.payload.addressId);
    // case 'CHECKOUT_VALUES_SET_SMS_MARKETING':
    //   return orderValues.setIn(['smsInfo', 'numberForMarketing'], action.phoneNumber);
    // case 'CHECKOUT_VALUES_SET_SELECTED_SHIPPING_PHONE_NUMBER':
    //   return orderValues.set('selectedShippingPhoneNumber', action.payload);
    case CheckoutConstants.CHECKOUT_ORDER_OPTIONS_SET_SHIPPING:
      return checkout.setIn(['options', 'shippingMethods'], action.shippingMethods);
    case CheckoutConstants.TOGGLE_ZIP_CODE_LOADER:
      return checkout.setIn(['values', 'shipping', 'zipCodeLoader'], action.payload);
    case CheckoutConstants.EDIT_SHIPPING:
      return checkout.setIn(['uiFlags', 'editShipping'], action.payload);
    case CheckoutConstants.APPLE_PAY_LOADER:
      return checkout.setIn(['uiFlags', 'appleLoaderState'], action.payload);
    case CheckoutConstants.UPDATE_CART_SHIPPING_METHOD:
      return checkout.setIn(['values', 'shipping'], action.shipping);
    case CheckoutConstants.EXPRESS_AFTERPAY_FLOW:
      return checkout.setIn(['uiFlags', 'isExpressAfterPayFlow'], action.payload);
    case CheckoutConstants.IS_EXPRESS_CALL_THROUGH_PLCC_FAILURE:
      return checkout.setIn(['values', 'isExpressCallDoneThroughPlccIcFailure'], action.payload);
    case CheckoutConstants.IS_SUBMIT_ORDER_ERROR:
      return checkout.setIn(['values', 'isSubmitOrderError'], action.payload);
    case CheckoutConstants.IS_SUBMIT_ORDER_ERROR_CODE:
      return checkout.setIn(['values', 'isSubmitOrderErrorCode'], action.payload);
    // case CheckoutConstants.CHECKOUT_ORDER_OPTIONS_SET_PAYPAL_PAYMENT:
    //   return checkout.setIn(['options', 'shippingMethods'], action.shippingMethods);
    // case 'CHECKOUT_ORDER_OPTIONS_SET_GIFT_WRAP':
    //   return merge(orderOptions, { giftWrapOptions: action.giftWrapOptions });
    case CheckoutConstants.ADD_CREDIT_CARD_RECAPTCHA:
      return checkout.set('recaptcha', fromJS(action.payload));
    case CheckoutConstants.UPDATE_SELECTED_METHOD:
      return checkout.setIn(['values', 'shipping', 'method'], action.shippingMethod);
    default:
      return uiFlagReducer(checkout, action);
  }
}
